export default __webpack_public_path__ + "static/media/Cand_Nric_List_All.7aa5a3d4.csv";